export default __webpack_public_path__ + "static/media/tete36.96e1056b.png";